import { Component, Input, OnInit } from '@angular/core';
import { NavController, ModalController } from 'ionic-angular'
import { RcsModalEstimateline } from '../rcs-modal-estimateline/rcs-modal-estimateline';
import { OrderlinePrototyp } from '../../assets/shared/orderline.object';
import {RcsConnectorIndexDbProvider} from "../../providers/rcs-connector-index-db/rcs-connector-index-db";

@Component({
  selector: 'rcs-kd-job-offer',
  templateUrl: 'rcs-kd-job-offer.html'
})
export class RcsKdJobOfferComponent implements OnInit{

  @Input() job;
  @Input() job_type;
  private user: any

  constructor(
    private nav_controller: NavController,
    private modal_controller: ModalController,
    private db: RcsConnectorIndexDbProvider) {}

  ngOnInit():void{
    this.db.search_by_key('login', 'user_login').subscribe(
      user => { this.user = user }
    )
  }

  public add_orderline(){
      let prototyp = new OrderlinePrototyp();
      prototyp.id = Math.random();
      prototyp.product_id = [0, null];
      prototyp.product_uom = [34, null];
      prototyp.route = [0, null];
      prototyp.qty = 0;
      prototyp.state_app = 'new'
      prototyp.state = 'new'
      prototyp.create_uid = [this.user.uid, this.job.monteur_id[1]]
      //this.job.orderline.push(prototyp);
      this.nav_controller.push('JobImplementationPage', {'finishline': prototyp, 'job_mode': 'offer', job: this.job});
  }

  // Speichert Änderungen im Job
  public edit_orderline(finishline:any){
      this.nav_controller.push('JobImplementationPage', {'finishline': finishline, 'job_mode': 'offer', job: this.job})
  }


  // Entfernt eine Orderline aus der lokalen Datenbank und sendet einen Task an das Odoo
  public delete_orderline(orderline){
    //this.kd_data_service.delete_subrecord('rcs.kdienst.auftrag.line', orderline.id)
    let keys = Object.keys(this.job.orderline);
      for(let key of keys){
        if (this.job.orderline[key].id == orderline.id){
          this.job.orderline[key].state = 'delete';
          //this.job.orderline.splice(key, 1);
        break;
      }
    }
  }

  // Fügt eine Schaetzline(Estimate) dem Job hinzu
  public add_estimate(){
    let modal_estimate_page = this.modal_controller.create(
      RcsModalEstimateline, {}, { enableBackdropDismiss: false }
    );
    modal_estimate_page.present();
    setTimeout(() => {
      modal_estimate_page.onDidDismiss(
        (data) => {
          if (data){
            let estimate = data.estimate;
            estimate.id = Math.random();
            estimate.state = 'new';
            estimate.state_app = 'new';
            this.job.schaetzline.push(estimate);
          }
        }
      )
    }, 500);
  }

  // Speichert Änderungen an der Schaetzline(Estimate) im Job
  public edit_estimate(estimate:any){
    let modal_estimate_page = this.modal_controller.create(
      RcsModalEstimateline, { estimate: estimate }, { enableBackdropDismiss: false }
    );
    modal_estimate_page.present();
    modal_estimate_page.onDidDismiss(
      (data) => {
        if (data){
          let estimate = data.estimate;
          for (let item of this.job.schaetzline){
            if (item.id == estimate.id){ item = estimate }
          }
        }else{
          const time = estimate.dauer.split(':');
          estimate.dauer = parseFloat(time[0]) + (time[1] / 60);
        }
      }
    )
  }

  // Entfernt eine Schaetzline(Estimate) aus der lokalen Datenbank und sendet einen Task an das Odoo
  public delete_estimate(estimate){
    let keys = Object.keys(this.job.schaetzline);
    for(let key of keys){
      if (this.job.schaetzline[key].id == estimate.id){
        setTimeout(() => {
          this.job.schaetzline[key].state = 'delete';
        }, 500);
        break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/rcs-kd-job-offer/rcs-kd-job-offer.ts